import { render, staticRenderFns } from "./LayoutWithAside.vue?vue&type=template&id=62dc2440&scoped=true&functional=true"
import script from "./LayoutWithAside.vue?vue&type=script&lang=js"
export * from "./LayoutWithAside.vue?vue&type=script&lang=js"
import style0 from "./LayoutWithAside.vue?vue&type=style&index=0&id=62dc2440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "62dc2440",
  null
  
)

export default component.exports